import { EmailContactData } from '../../../../../models/EmailContact';
import CopyContactIdButton from '../CopyContactIdButton/CopyContactIdButton';
import { Box, Typography } from '@coolblue-development/freddy';

// Display-only label; the subject actually sent comes from replySubject in useSendEmail.
const NO_SUBJECT_LABEL = '(no subject)';

interface ReplyHeaderProps {
  data: EmailContactData;
}

const ReplyHeader = ({ data }: ReplyHeaderProps): JSX.Element => {
  return (
    <Box
      sx={{
        border: '1px solid #DDDDDD',
        borderRadius: '4px 4px 0 0',
        padding: '12px'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
        data-testid="reply-header"
      >
        <Typography
          variant="h6"
          sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}
          data-testid="reply-subject"
        >
          {data.subject ?? NO_SUBJECT_LABEL}
        </Typography>
        <CopyContactIdButton contactId={data.contactId} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        {data.from && (
          <Typography variant="body" color="subtle" data-testid="reply-to" fontWeight={500}>
            To: {data.from}
          </Typography>
        )}
        <Typography variant="body" color="subtle" data-testid="reply-cc" fontWeight={500}>
          Cc:
        </Typography>
      </Box>
    </Box>
  );
};

export default ReplyHeader;
